import React, { useEffect } from "react";
import {
  Table, Select, Input, Button, message, Modal, Form, DatePicker, Upload,
  Space, TimePicker, Col, Row, Spin
} from "antd";
import { SearchOutlined } from "@ant-design/icons";
import styled from "styled-components";
import { ReactComponent as Edit } from "../../assets/Edit_Pencil_01.svg";
import { ReactComponent as Trash } from "../../assets/trash.svg";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { useState } from "react";
import { ReactComponent as Tick } from "../../assets/tick.svg";
import { CALL_API } from "common/API";
import { ReactComponent as UploadIcon } from "../../assets/uploadicon.svg";
import { getClientid, getUserInfo, getUserList, getMenuList, getUserRoleId } from "redux/selectors";
import { STATUS_CODE } from "common/Constants";
import { connect } from "react-redux";
import moment from "moment";
import { object } from "prop-types";
import { find, get } from "lodash";
import ReportIncident from "./ReportIncident";

const CustomStyle = styled.div`
// .ant-modal-mask {
//   background: rgba(0, 0, 0, 0.1) !important; /* Light transparent background */
// }
.ant-modal-content {
  box-shadow: none !important; /* Removes shadow */
  background-color: white !important;
  border-radius: 10px; /* Adjust if needed */
}
.ant-modal {
  box-shadow: none !important; /* Ensures no extra shadow */
}

  .ant-table {
    border: 1px solid #e2e2e8;
    border-radius: 8px;
  }
  .ant-table-thead > tr > th {
    font-size: 16px;
    font-weight: 500;
    color: #1f243b;
  }
  .ant-table-tbody > tr > td {
    font-size: 15.2px;
    font-weight: 400;
    color: #636980;
  }

  .total {
    display: flex;
    // justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
  }

  .in {
    font-size: 16px;
    font-weight: 500;
    color: #333;
  }

  .inci {
    font-weight: 400 !important;
    font-size: 14px !important;
  }

  .action-dropdown .ant-select-selector {
    width: 200px;
    height: 34px;
    border-radius: 24px;
    font-weight: 400;
    font-size: 14px;
    color: #636980;
     margin-left: 0px;
  }

  .search {
    width: 200px;
    height: 34px;
    border-radius: 24px;
    font-weight: 400;
    font-size: 14px;
    color: #636980;
  margin-left: 2px;
  }

  /* Hover effect to change color on hover */
  .dropdown-container a:hover {
    color: #1890ff;
  }

  .dropdown-container a .anticon {
    margin-left: 5px; /* Adjust spacing */
    font-size: 9px; /* Make the arrow smaller */
  }
     .datepicker-style {
    width: 180px;
    height: 34px;
    border-radius: 24px;
  }
      .date-range-container {
    display: flex;
  
  }
  .action-icons {
    display: none;
    gap: 16px; /* Hide by default */
  }

  .ant-table-tbody > tr:hover .action-icons {
    display: flex; /* Show only on row hover */
  }
  .custom-row td {
    height: 70px; /* Adjust as needed */
    vertical-align: middle;
  }
  .suspend-text {
    color: #f28916;
  }

  .res-text {
    color: #08c108;
  }

  .dis-text {
    color: #ee2738;
  }
  .ant-modal {
    z-index: 9999 !important; /* Ensure the modal stays on top */
  }
  .ant-modal-body {
    overflow-y: auto; /* Add this if the modal content overflows */
  }

  // .ant-modal-mask {
  //   background-color: rgba(0, 0, 0, 0.5); /* Semi-transparent mask */
  //   z-index: 9998; /* Ensure the mask is beneath the modal */
  // }
   
 .adjust-margin {
  margin-top: 10px;
  margin-left:3px;
}
  @media (max-width: 768px) {
    .total {
      display: block !important;
    }
    .search {
      margin-bottom: 10px !important;
      margin-left: 0 !important;
    }
    .action-dropdown {
      margin-bottom: 10px !important;
      margin-left: -12px !important;
    }
  }
`;
const StyledModal = styled(Modal)`

  .ant-modal {
    background: rgba(0, 0, 0, 0.04) !important;
    // top: 0 !important; /* Moves the modal to the top of the screen */
    // margin-top: 0 !important; /* Remove any margin at the top */
    // position: fixed !important; /* Ensure it stays fixed to the top */
  }
  // .ant-modal-mask{
  //   background-color: rgba(0, 0, 0, 0.04) !important;
  // }
  .ant-modal-title {
    font-size: 18px;
    font-weight: 500;
  }
  .custom-cancel-button {
    width: 130px;
    height: 34px;
    border-radius: 8px;
    border: 1px solid #2d53da;
    font-size: 16px;
    font-weight: 400;
    color: #2d53da;
  }
  .custom-ok-button {
    width: 130px;
    height: 34px;
    border-radius: 8px;
    font-size: 16px;
    font-weight: 400;
    background-color: #2d53da;
    color: #ffffff;
  }
  .form-split {
    display: flex;
    gap: 32px;
  }
  .input-width {
    width: 50%;
  }
  .form-datepicker {
    width: 100%;
  }
  .upload-style {
    width: 190px;
    height: 37px;
    border-radius: 5px;
    background-color: #e3e8fc;
    font-size: 16px;
    font-weight: 400;
    color: #2d53da;
  }
  .upload-icon {
    margin-bottom: 3px;
  }
  .button-style {
    gap: 20px;
  }
  .success-modal {
    align-items: center;
    display: flex;
    flex-direction: column;
    gap: 10px;
  }
  .sent-successfully {
    font-size: 16px;
    font-weight: 400;
  }
  .suspension-from {
    display: flex;
    gap: 150px;
  }
  .suspension-to {
    display: flex;
    gap: 167px;
  }
  .payment-type {
    display: flex;
    gap: 170px;
  }
  .suspension-title {
    font-weight: 500;
    font-size: 14px;
    color: #636980;
  }
  .suspension-data {
    font-weight: 400;
    font-size: 16px;
  }
  .close-button {
    width: 130px;
    height: 34px;
    border-radius: 8px;
    border: 1px solid #2d53da;
    color: #2d53da;
  }
  .no-button {
    width: 130px;
    height: 34px;
    border-radius: 8px;
    border: 1px solid #2d53da;
    color: #2d53da;
  }
  .yes-button {
    width: 130px;
    height: 34px;
    border-radius: 8px;
    background-color: #2d53da;
    color: #ffffff;
  }
  .delete-modal-text {
    font-weight: 400;
    font-size: 16px;
    color: #636980;
  }
  .yes-no-button {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
  }
`;
const props = {
  name: "file",
  action: "https://660d2bd96ddfa2943b33731c.mockapi.io/api/upload",
  headers: {
    authorization: "authorization-text",
  },
  onChange(info) {
    if (info.file.status !== "uploading") {
      console.log(info.file, info.fileList);
    }
    if (info.file.status === "done") {
      message.success(`${info.file.name} file uploaded successfully`);
    } else if (info.file.status === "error") {
      message.error(`${info.file.name} file upload failed.`);
    }
  },
};
const MyIncident = ({ userInfo, ClientId, userList, menuList, userRoleId }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [filteredData, setFilteredData] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [selectedType, setSelectedType] = useState(null);
  const history = useHistory();
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [showDateRange, setShowDateRange] = useState(false);
  const [selectedDateRange, setSelectedDateRange] = useState(null);
  const Menulist = menuList[userRoleId] || Object.values(menuList)[0]; // Added Menulist logic
  const dataSource = [
    {
      key: "1",
      Incident_ID: "IN123456",
      Name: "Near Miss",
      Employee_ID: "25th Aug 2024",
      Incident_Type: "11:00 AM",
      Location: "Near Office",
      Reported_on: "25th Aug 2024",
      Status: "Waiting for Review",
    },
    {
      key: "2",
      Incident_ID: "IN123456",
      Name: "Near Miss",
      Employee_ID: "25th Aug 2024",
      Incident_Type: "11:00 AM",
      Location: "Near Office",
      Reported_on: "25th Aug 2024",
      Status: "Under Review",
    },
    {
      key: "3",
      Incident_ID: "IN123456",
      Name: "Near Miss",
      Employee_ID: "25th Aug 2024",
      Incident_Type: "11:00 AM",
      Location: "Near Office",
      Reported_on: "25th Aug 2024",
      Status: "Waiting for Review",
    },
    {
      key: "4",
      Incident_ID: "IN123456",
      Name: "Near Miss",
      Employee_ID: "25th Aug 2024",
      Incident_Type: "11:00 AM",
      Location: "Near Office",
      Reported_on: "25th Aug 2024",
      Status: "Dismissed",
    },
    {
      key: "5",
      Incident_ID: "IN123456",
      Name: "Near Miss",
      Employee_ID: "25th Aug 2024",
      Incident_Type: "11:00 AM",
      Location: "Near Office",
      Reported_on: "25th Aug 2024",
      Status: "Resolved",
    },
    {
      key: "6",
      Incident_ID: "IN123456",
      Name: "Near Miss",
      Employee_ID: "25th Aug 2024",
      Incident_Type: "11:00 AM",
      Location: "Near Office",
      Reported_on: "25th Aug 2024",
      Status: "Under Review",
    },
  ];
  const [selectedRecord, setSelectedRecord] = useState({});
  const handleEditDisciplinary = (record) => {
    setSelectedIncidentId(record.incidentId);
    setSelectedRecord(record)

    setIsModalOpen(true);
  };
  useEffect(() => {
  }, [selectedRecord]);
  const [isDeleteOpen, setIsDeleteOpen] = useState(false);
  const [isDeletedModalOpen, setIsDeletedModalOpen] = useState(false);
  const [isSavedModalOpen, setIsSavedModalOpen] = useState(false);

  const handleDeleteClick = (id) => {
    setIncidentToDelete(id); // Update state with the clicked ID
    setIsDeleteOpen(true);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };
  const handleDeleteCancel = () => {
    setIsDeleteOpen(false);
  };


  const [form] = Form.useForm();
  const [showLoader, toggleLoader] = useState(false);
  const [assetsData, setDisData] = useState([]);
  const [selectedIncidentId, setSelectedIncidentId] = useState(null);
  const [incidentToDelete, setIncidentToDelete] = useState(null);
  const [selectedStatus, setSelectedStatus] = useState("");
  const [loading, setLoading] = useState(false);
  const getDisData = async () => {
    try {
      setLoading(true);

      const { data, code } = await CALL_API(
        `incident/${userInfo?.userid}`,
        "get",
        {}
      );

      if (code === "SUCCESS" && Array.isArray(data)) {
        setDisData([...data]?.reverse());
        setFilteredData(data);
      } else {
        console.error("Invalid API Response:", data);
        message.error("Failed to fetch data. Please try again.");
      }
    } catch (error) {
      console.error("API Error:", error);
      message.error("Something went wrong while fetching data.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getDisData();
  }, []);

  const columns = [
    {
      title: "Incident ID",
      dataIndex: "incidentId",
      key: "incidentId",

    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",

    },
    {
      title: "Employee ID",
      dataIndex: "employeeId",
      key: "employeeId",

    },
    {
      title: "Incident Type",
      dataIndex: "type",
      key: "type",

    },
    {
      title: "Location",
      dataIndex: "incidentlocation",
      key: "incidentlocation",
      render: (text) =>
        text
          ? text
            .split(" ")
            .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
            .join(" ")
          : "",

    },
    {
      title: "Reported on",
      dataIndex: "updatedAt",
      key: "updatedAt",

      render: (text) => (text ? moment(text).format("Do MMMM YYYY") : "-"),
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",

      render: (text, record) => {
        let displayStatus = text;

        if (text === "Commented") {
          if (record?.actiontimeline?.length > 0) {

            let foundPreviousStatus = false;
            for (let i = record.actiontimeline.length - 1; i >= 0; i--) {
              if (record.actiontimeline[i].actionmoveon !== "Commented") {
                displayStatus = record.actiontimeline[i].actionmoveon;
                foundPreviousStatus = true;
                break;
              }
            }

            if (!foundPreviousStatus) {
              displayStatus = "Waiting for Review";
            }
          } else {

            displayStatus = "Waiting for Review";
          }
        }


        if (displayStatus === "Waiting for Review") {
          return (
            <span className="clearance-text" style={{ cursor: "pointer" }}>
              {displayStatus}
            </span>
          );
        } else if (displayStatus === "Under Review") {
          return (
            <span className="suspend-text" style={{ cursor: "pointer" }}>
              {displayStatus}
            </span>
          );
        } else if (displayStatus === "Resolved") {
          return (
            <span className="res-text" style={{ cursor: "pointer" }}>
              {displayStatus}
            </span>
          );
        } else if (displayStatus === "Dismissed") {
          return (
            <span className="dis-text" style={{ cursor: "pointer" }}>
              {displayStatus}
            </span>
          );
        }
        return <span>{displayStatus}</span>;
      },
    },


    {
      key: "actions",
      width: 130,
      height: 50,
      render: (_, record) => {
        let displayStatus = record.status;

        if (record.status === "Commented") {
          if (record?.actiontimeline?.length > 0) {
            let foundPreviousStatus = false;
            for (let i = record.actiontimeline.length - 1; i >= 0; i--) {
              if (record.actiontimeline[i].actionmoveon !== "Commented") {
                displayStatus = record.actiontimeline[i].actionmoveon;
                foundPreviousStatus = true;
                break;
              }
            }
            if (!foundPreviousStatus) {
              displayStatus = "Waiting for Review";
            }
          } else {
            displayStatus = "Waiting for Review";
          }
        }

        // Only show edit/delete icons if final display status is "Waiting for Review"
        return displayStatus === "Waiting for Review" ? (
          <div className="action-icons">
            {Menulist?.find(
              (item) =>
                item?.key === "myincident" &&
                item?.permission.edit
            ) && (<Edit
              onClick={(event) => {
                event.stopPropagation();
                const updatedRecord = {
                  ...record,
                  time: record?.time ? moment(record.time, "HH:mm:ss") : null,
                  updatedAt: record?.updatedAt ? moment(record.updatedAt) : null,
                };
                handleEditDisciplinary(updatedRecord);
                form.setFieldsValue(updatedRecord);
                setIsModalOpen(true);
              }}
            />)}
            {Menulist?.find(
              (item) =>
                item?.key === "myincident" &&
                item?.permission.delete
            ) && (
                <Trash
                  onClick={(event) => {
                    event.stopPropagation();
                    handleDeleteClick(record?.incidentId);
                  }}
                />)}
          </div>
        ) : null;
      },
    }



  ];
  const disableToDate = (current) => {
    return fromDate ? current && current.isBefore(fromDate, "day") : false;
  };
  const deleteIncident = async () => {
    if (!incidentToDelete) {
      message.error("Invalid incident ID.");
      return;
    }
    setLoading(true);
    try {
      const response = await CALL_API(
        `incident/${ClientId}/${incidentToDelete}`,
        "delete"
      );

      if (response.code === "SUCCESS") {
        setIsDeleteOpen(false);
        await getDisData();
        setIsDeletedModalOpen(true);
        setTimeout(() => {
          setIsDeletedModalOpen(false);
        }, 1000);
        return true;
      } else {
        message.error("Failed to delete incident. Please try again.");
        return false;
      }
    } catch (error) {
      console.error("Delete API Error:", error);
      message.error("Something went wrong while deleting.");
      return false;
    }
    finally {
      setLoading(false);
    }
  };

  const getDisplayStatus = (incident) => {
    let displayStatus = incident.status;
    if (displayStatus === "Commented") {
      if (incident?.actiontimeline?.length > 0) {
        let foundPreviousStatus = false;
        for (let i = incident.actiontimeline.length - 1; i >= 0; i--) {
          if (incident.actiontimeline[i].actionmoveon !== "Commented") {
            displayStatus = incident.actiontimeline[i].actionmoveon;
            foundPreviousStatus = true;
            break;
          }
        }
        if (!foundPreviousStatus) {
          displayStatus = "Waiting for Review";
        }
      } else {
        displayStatus = "Waiting for Review";
      }
    }
    return displayStatus;
  };

  useEffect(() => {
    let filtered = [...assetsData]; // Avoid mutating the original array

    if (searchText) {
      filtered = filtered.filter((incident) =>
        incident?.incidentlocation?.toLowerCase().includes(searchText.toLowerCase())
      );
    }

    if (selectedType) {
      filtered = filtered.filter((incident) =>
        incident?.type?.trim().toLowerCase() === selectedType.toLowerCase()
      );
    }

    if (selectedStatus) {
      filtered = filtered.filter((incident) =>
        getDisplayStatus(incident)?.trim().toLowerCase() === selectedStatus.toLowerCase()
      );
    }

    // Date filtering logic
    let startDate, endDate;

    if (selectedDateRange === "Last week") {
      startDate = moment().subtract(1, "weeks").startOf("week");
      endDate = moment().subtract(1, "weeks").endOf("week");
    } else if (selectedDateRange === "Last month") {
      startDate = moment().subtract(1, "months").startOf("month");
      endDate = moment().subtract(1, "months").endOf("month");
    } else if (selectedDateRange === "Last 6 months") {
      startDate = moment().subtract(6, "months").startOf("month");
      endDate = moment().endOf("month");
    } else if (selectedDateRange === "custom" && fromDate && toDate) {
      startDate = moment(fromDate).startOf("day");
      endDate = moment(toDate).endOf("day");
    }

    if (startDate && endDate) {
      filtered = filtered.filter((incident) =>
        moment(incident.date).isBetween(startDate, endDate, null, "[]")
      );
    }

    setFilteredData(filtered);
  }, [searchText, selectedType, selectedStatus, selectedDateRange, fromDate, toDate, assetsData]);

  const handleSelectChange = (value) => {
    setSelectedDateRange(value);
    if (value === "custom") {
      setShowDateRange(true);
    } else {
      setShowDateRange(false);
      setFromDate(null);
      setToDate(null);
    }
  };
  const handleStatusChange = (value) => {
    setSelectedStatus(value);
  };

  return (
    <CustomStyle>
      <p style={{ fontWeight: 500, fontSize: 20 }}>My Incident</p>
      {/* Dropdown and Search */}
      <div className="totaldropdowns">
        <Row gutter={16}>
          <Col>
            <div>
              <Input
                className="search"
                placeholder="Search Location"
                prefix={<SearchOutlined />}
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
              />
            </div>
          </Col>
          <Col>
            <div className="dropdown-container">
              <Select placeholder="Incident Type" className="action-dropdown" onChange={(value) => setSelectedType(value)}
                allowClear>
                <Select.Option value="Workplace Injury">Workplace Injury</Select.Option>
                <Select.Option value="Hazardous Material Exposure">
                  Hazardous Material Exposure
                </Select.Option>
                <Select.Option value="Vehicle Accident">Vehicle Accident</Select.Option>
                <Select.Option value="Fire or Explosion">Fire or Explosion</Select.Option>
                <Select.Option value="Medical Emergency">Medical Emergency</Select.Option>
                <Select.Option value="Near Miss">Near Miss</Select.Option>
              </Select>
            </div>
          </Col>
          <Col>
            <div className="dropdown-container">
              <Select placeholder="Date" className="action-dropdown" onChange={handleSelectChange}
                allowClear>
                <Select.Option value="Last week">Last week</Select.Option>
                <Select.Option value="Last month">Last month</Select.Option>
                <Select.Option value="Last 6 months">Last 6 months</Select.Option>
                <Select.Option value="custom">Custom Date range</Select.Option>
              </Select>
            </div>
          </Col>
          {showDateRange && ( // Conditionally render the date pickers
            <div className="date-range-container">
              <Col>
                <div>
                  <DatePicker placeholder="From" format="DD-MM-YYYY" className="datepicker-style" onChange={(date) => {
                    setFromDate(date);
                    if (toDate && date && toDate.isBefore(date, "day")) {
                      setToDate(null); // Reset ToDate if it's before the new FromDate
                    }
                  }} />
                </div>
              </Col>
              <Col>
                <div>
                  <DatePicker placeholder="To" format="DD-MM-YYYY" className="datepicker-style" disabledDate={disableToDate} // Disable past dates before FromDate
                    onChange={(date) => setToDate(date)} />
                </div>
              </Col>
            </div>
          )}
          <Col className={`dropdown-container ${showDateRange ? "adjust-margin" : ""}`}>
            <div className="dropdown-container">
              <Select placeholder="Status" className="action-dropdown" onChange={handleStatusChange} allowClear>
                <Select.Option value="Waiting for Review">Waiting for Review</Select.Option>
                <Select.Option value="Under Review">Under Review</Select.Option>
                <Select.Option value="Resolved">Resolved</Select.Option>
                <Select.Option value="Dismissed">Dismissed</Select.Option>
              </Select>
            </div>
          </Col>
        </Row>
      </div>
      <br />
      <p style={{ fontWeight: 400, fontSize: 16 }}>
        Total Incident: {filteredData.length}
      </p>


      <Spin spinning={loading} size="medium">
        <Table
          dataSource={filteredData}
          columns={columns}
          pagination={true}
          rowClassName={() => "custom-row"}
          onRow={(record) => {
            return {
              onClick: (e) => {
                e.stopPropagation();
                history.push({
                  pathname: `/ViewIncident/${record.incidentId}`,  // Navigate to view page
                  state: { incidentData: record, page: "myincident" }, // Pass the selected row data

                });
              },
            };
          }}
          scroll={{ x: "max-content" }}
          style={{ cursor: "pointer" }}
        />
      </Spin>
      <ReportIncident
        isModalVisible={isModalOpen}
        closeModal={() => setIsModalOpen(false)}
        details={selectedRecord}
        selectedIncidentId
      />
      <StyledModal
        width={470}
        // height={140}
        footer={false}
        closable={false}
        open={isDeleteOpen}
        onCancel={handleDeleteCancel}
        style={{ marginTop: "100px" }}

      >
        <p className="delete-modal-text">
          Are you sure you want to delete this incident?
        </p>
        <br />
        <div className="yes-no-button">
          <Button onClick={(e) => { e.stopPropagation(); handleDeleteCancel(); }} className="no-button">
            No
          </Button>
          <Button onClick={(e) => { e.stopPropagation(); deleteIncident(); }} className="yes-button" loading={loading}>
            Yes
          </Button>

        </div>
      </StyledModal>
      <StyledModal
        width={190}
        height={70}
        open={isDeletedModalOpen}
        onCancel={() => setIsDeletedModalOpen(false)}
        footer={false}
        closable={false}
        style={{ marginTop: "130px" }}
      >
        <div className="success-modal">
          <Tick />
          <p className="sent-successfully">Deleted</p>
        </div>
      </StyledModal>
    </CustomStyle>
  );
};
const mapStateToProps = (state) => ({
  userRoleId: getUserRoleId(state),

  userInfo: getUserInfo(state),
  ClientId: getClientid(state),
  userList: getUserList(state),
  menuList: getMenuList(state),
});
export default connect(mapStateToProps)(MyIncident);
